import React from 'react';
import DataTableActionMenu from '../../../Elements/DataTable/DataTableActionMenu';
import ErrorMessage from '../../../Elements/ErrorMessage';

// Actions cell for the gallery list grid — the row "three-dot" menu.
// Lives in its own .tsx (JSX is not allowed in DemoListItem.ts) and mirrors the
// real pattern: an item-class static returns <DataTableActionMenu options={...} />
// from the column descriptor's data function (see ClientItem.getActionsCellContent).
export default function getDemoActionsCellContent(item) {
  return (
    <DataTableActionMenu
      options={[
        {
          text: 'Edit',
          iconName: 'fa-solid fa-edit',
          onClick: () => ErrorMessage.SetInfo(`Edit clicked for ${item.ShopName} (demo — nothing happens).`),
        },
        {
          text: 'Create Invoice',
          iconName: 'fa-solid fa-file-invoice-dollar',
          onClick: () => ErrorMessage.SetInfo(`Create Invoice clicked for shop #${item.ShopId} (demo).`),
        },
        { separator: true },
        {
          text: `Shop Id: (${item.ShopId})`,
          iconName: 'fa-brands fa-grav',
          onClick: () => {},
          disabled: true,
        },
        {
          text: 'Hidden for inactive shops',
          iconName: 'fa-solid fa-eye-slash',
          onClick: () => ErrorMessage.SetInfo('Only visible while the shop is active (demo).'),
          hide: () => !item.IsActive,
        },
      ]}
    />
  );
}
